import { Dialog, DialogContent } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

import L from 'leaflet';

import { IActionForProvider } from '../../../Lib/Actions/actions';
import PopupAppBar from '../../Common/PopupAppBar';
import SettingsList from './settingsList';
import { ISettingsService } from '../../../Settings/serviceTypes';
import { ITileCache } from '../../MapComponents/TileCache/types';


interface SettingsPopupProps {
    action: IActionForProvider<{ map: L.Map }, void>;
    service: ISettingsService,
    tileCache: ITileCache
}

const SettingsPopup = (props: SettingsPopupProps): JSX.Element => {

    const map = props.action.params?.map;

    const handleClose = () => {
      props.service.save()
      props.action.cancel();
    };

    return (
      <Dialog
          fullScreen
          open={props.action.isActive}
          onClose={handleClose}
      >
        <PopupAppBar title="Settings" icon={<SettingsIcon/>} onClose={handleClose} />

        <DialogContent>
          
        {map &&
          <SettingsList 
            service={props.service} 
            tileCache={props.tileCache}
            map={map}
          />
        }

        </DialogContent>

      </Dialog>
    );
};

export default SettingsPopup;